module.exports = __webpack_public_path__ + "img/other-link-bg.4dd1f3c9.png";